// Angular
import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
// Model
import {
	BroadcastEventModel,
	BroadcastService,
	CONTENT_LOADER_EVENT,
	ToasterType
} from '@cv-invision/core';
// Service
import { OrderInboxService } from '../service/order-inbox.service';
// Store
import { Store } from '@ngxs/store';
import { InboxState } from '../state/inbox.state';
import {
	SetOrderDocumentManually,
	SetOrderisRecalled
} from '../../quality/state/actions/quality.actions';

export const RESUBMIT_ORDER_EVENT = 'resubmitOrderEvent';
export const RELOAD_INBOX = 'reloadInboxEvent';

export interface ResubmitCreatedOrder {
	orderId?: number;
	file?: File;
}

@Component({
	selector: 'cv-resubmit',
	encapsulation: ViewEncapsulation.None,
	templateUrl: './resubmit-order.component.html',
	styleUrls: ['./resubmit-order.component.scss']
})
export class ReSubmitOrderComponent {
	isResubmit: boolean;
	dataOrder: any;
	filesDropMessage = 'Upload the XML file that you want to recall.';
	isImported: boolean;
	canResubmit: boolean;
	resubmitCreatedForm: ResubmitCreatedOrder = {
		orderId: null,
		file: null
	};

	constructor(
		private inboxService: OrderInboxService,
		private broadcastService: BroadcastService,
		private router: Router,
		private store: Store
	) {
		this.canResubmit = false;
		this.isImported = true;
		this.isResubmit = false;
		this.registerResubmitListener();
	}

	/**
	 * open rejection box
	 */
	toggleReSubmitBox(): void {
		this.isResubmit = false;
		this.dataOrder = null;
		this.resubmitCreatedForm.file = null;
		this.canResubmit = false;
		this.resubmitCreatedForm.orderId = null;
	}

	/**
	 * Get the latest file Uploaded
	 * @param event
	 */
	onFilesDropped(event: any): void {
		this.canResubmit = event.length ? true : false;
		this.resubmitCreatedForm.file = event[0];
	}

	/**
	 * resubmit an order that has been imported
	 */
	reSubmitImported(): void {
		this.isResubmit = false;
		this.showLoader(true);
		const externalId = this.dataOrder.externalId;
		const externalProvider = this.dataOrder.externalProvider;
		const orderId = this.dataOrder.id;
		this.dataOrder = null;
		this.inboxService.reSubmitOrderImported(orderId).subscribe(
			response => {
				this.showLoader(false);
				if (response.isValid) {
					this.setResumitOrder(orderId);
				}
			},
			error => {
				this.showLoader(false);
				// Something goes wrong, update the List
				this.broadcastService.broadcast({
					name: RELOAD_INBOX,
					event: { reload: true }
				});
			}
		);
	}

	/**
	 *re resubmit an order thats bee create
	 */
	reSubmitCreated(): void {
		this.isResubmit = false;
		this.showLoader(true);
		this.dataOrder = null;
		this.inboxService.reSubmitOrderCreated(this.resubmitCreatedForm).subscribe(
			response => {
				this.showLoader(false);
				if (response.isValid) {
					this.setResumitOrder(this.resubmitCreatedForm.orderId);
				}
			},
			error => {
				this.showLoader(false);
				// Something goes wrong, update the List
				this.broadcastService.broadcast({
					name: RELOAD_INBOX,
					event: { reload: true }
				});
			}
		);
	}

	/**
	 * set order doc and redirect order
	 */
	private setResumitOrder(orderId: number): void {
		const selectedOrderId = this.store.selectSnapshot(InboxState.getSelectedOrderId);
		if (orderId === selectedOrderId) {
			this.store.dispatch(new SetOrderDocumentManually(null));
		}
		this.broadcastService.broadcast({
			name: ToasterType.SUCCESS,
			event: {
				message: `Order <span class="order-id">${orderId}</span> is being recalled`
			}
		});
		setTimeout(() => {
			this.store.dispatch(new SetOrderisRecalled(true));
			this.router.navigate(['/intelligence/quality/overview', orderId]);
		}, 500);
	}

	/**
	 * Register Lister to Show/Hide the Loader
	 */
	private registerResubmitListener(): void {
		this.broadcastService.on(RESUBMIT_ORDER_EVENT, (broadcast: BroadcastEventModel) => {
			this.isResubmit = broadcast.event.isResubmit;
			this.dataOrder = broadcast.event.data;
			const { externalId, externalProvider, id } = this.dataOrder;
			if (!externalId && !externalProvider) {
				this.isImported = false;
				this.resubmitCreatedForm.orderId = id;
			} else {
				this.isImported = true;
			}
		});
	}

	/**
	 * Show/Hide the Loader
	 * @param isShowing
	 */
	private showLoader(isShowing: boolean): void {
		this.broadcastService.broadcast({
			name: CONTENT_LOADER_EVENT,
			event: {
				isLoader: isShowing,
				message: 'We are recalling the Order'
			}
		});
	}
}
